import { Search } from 'lucide-react';
import * as React from 'react';

import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface SearchTriggerProps {
  isExpanded?: boolean;
  className?: string;
  onClick: () => void;
}

export function SearchTrigger({
  isExpanded,
  className,
  onClick,
}: SearchTriggerProps): React.ReactElement {
  return (
    <Button
      variant="outline"
      onClick={onClick}
      className={cn(
        'group relative flex h-10 items-center gap-2 rounded-xl text-sm transition-all duration-300 ease-in-out',
        'border-border/50 bg-background/80 text-muted-foreground hover:border-border hover:bg-background hover:text-foreground',
        'shadow-sm backdrop-blur-sm hover:shadow-md',
        'hover:scale-105 active:scale-95',
        isExpanded
          ? 'w-full justify-start overflow-hidden px-3 py-2'
          : 'h-10 w-auto justify-center rounded-xl p-0',
        className
      )}
      data-search-trigger
    >
      <div className="relative flex-shrink-0">
        <Search className="h-4 w-4 transition-all duration-200 ease-in-out group-hover:scale-110 group-hover:text-primary" />
      </div>
      {isExpanded && (
        <span className="ml-2 whitespace-nowrap text-sm font-medium transition-colors duration-200 group-hover:text-foreground">
          Search anything...
        </span>
      )}
      {isExpanded && (
        <kbd className="ml-auto h-6 select-none items-center gap-1 rounded-lg border border-border/50 bg-muted/50 px-2 text-[10px] font-medium text-muted-foreground/80 shadow-sm md:inline-flex">
          <span className="text-xs">⌘</span>K
        </kbd>
      )}
    </Button>
  );
}

SearchTrigger.defaultProps = {
  isExpanded: false,
  className: undefined,
};
